import { Dispatch } from 'react'
import BudgetGuidance, { BudgetGuidanceType } from '../BudgetGuidance'
import BudgetNotes from '../BudgetNotes'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import BudgetCaption from '../BudgetCaption'
import { Currency } from '../../../../Types/generated-types'

interface LFBudgetOptionsInput {
  budget: number | ''
  currency?: Currency
  setBudgetGuidance: Dispatch<BudgetGuidanceType>
  budgetNotes: string
  setBudgetNotes: Dispatch<string>
}

const LFBudgetOptions = ({
  budget,
  currency,
  setBudgetGuidance,
  budgetNotes,
  setBudgetNotes,
}: LFBudgetOptionsInput): JSX.Element => {
  const { brief } = useBriefContext()

  return (
    <>
      <BudgetCaption
        budget={budget || undefined}
        currencySymbol={currency?.code}
        numGuests={brief.capacities ?? 1}
      />

      <BudgetGuidance brief={brief} currency={currency} setBudgetGuidance={setBudgetGuidance} />
      <BudgetNotes
        value={budgetNotes}
        onBudgetNotesChange={({ target }) => setBudgetNotes(target.value)}
      />
    </>
  )
}

export default LFBudgetOptions
